// Loader.jsx
import React from 'react';
import './loader.css';

const Loader = () => {
  return (
    <div className="custom-chat-loader">
      <div className="custom-chat-loader-dot"></div>
      <div className="custom-chat-loader-dot"></div>
      <div className="custom-chat-loader-dot"></div>
    </div>
  );
};

export default Loader;